import { render } from "./Core.vue?vue&type=template&id=12283a34&ts=true"
import script from "./Core.vue?vue&type=script&lang=ts"
export * from "./Core.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__